import React, { useState } from "react";
import {
  Stack,
  Box,
  Typography
} from "@mui/material";



export default function StatisticsCard(props) {

  const { statistics } = props;

  console.log("statistics ==> ", statistics)
  
  return (
    <>
      <Box className="dashboard-countbox">
                <Stack
                  spacing={2}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Stack
                    spacing={2}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box className="active-icons customer">
                      <span class="material-symbols-outlined">person</span>
                    </Box>
                    <Box>
                      <Typography className="sidebar-cout-title">
                        Active Customers
                      </Typography>
                      <Typography className="sidebar-cout-text">
                        { statistics.Customer_Desc }
                      </Typography>
                    </Box>
                  </Stack>
                  <Typography className="statement-count">{ statistics.Customer_KPI }</Typography>
                </Stack>
              </Box>
              <Box className="dashboard-countbox">
                <Stack
                  spacing={2}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Stack
                    spacing={2}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box className="active-icons projects">
                      <span class="material-symbols-outlined">
                        patient_list
                      </span>
                    </Box>
                    <Box>
                      <Typography className="sidebar-cout-title">
                        Active Projects
                      </Typography>
                      <Typography className="sidebar-cout-text">
                      { statistics.Project_Desc }
                      </Typography>
                    </Box>
                  </Stack>
                  <Typography className="statement-count">{ statistics.Project_KPI }</Typography>
                </Stack>
              </Box>
              <Box className="dashboard-countbox">
                <Stack
                  spacing={2}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Stack
                    spacing={2}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box className="active-icons brokers">
                      <span class="material-symbols-outlined">group</span>
                    </Box>
                    <Box>
                      <Typography className="sidebar-cout-title">
                        Active Brokers
                      </Typography>
                      <Typography className="sidebar-cout-text">
                      { statistics.Broker_Desc }
                      </Typography>
                    </Box>
                  </Stack>
                  <Typography className="statement-count">{ statistics.Broker_KPI }</Typography>
                </Stack>
              </Box>
              <Box className="dashboard-countbox">
                <Stack
                  spacing={2}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Stack
                    spacing={2}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box className="active-icons billing">
                      <span class="material-symbols-outlined">
                        receipt_long
                      </span>
                    </Box>
                    <Box>
                      <Typography className="sidebar-cout-title">
                        Open Billing
                      </Typography>
                      <Typography className="sidebar-cout-text">
                      { statistics.Billing_Desc }
                      </Typography>
                    </Box>
                  </Stack>
                  <Typography className="statement-count">{ statistics.Billing_KPI }</Typography>
                </Stack>
              </Box>
              <Box className="dashboard-countbox">
                <Stack
                  spacing={2}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Stack
                    spacing={2}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box className="active-icons invoices">
                      <span class="material-symbols-outlined">description</span>{" "}
                    </Box>
                    <Box>
                      <Typography className="sidebar-cout-title">
                        Open Invoices
                      </Typography>
                      <Typography className="sidebar-cout-text">
                      { statistics.Invoice_Desc }
                      </Typography>
                    </Box>
                  </Stack>
                  <Typography className="statement-count">{ statistics.Invoice_KPI }</Typography>
                </Stack>
              </Box>
    </>
  );
}
